import axios from 'axios';

axios.defaults.withCredentials = true;
// BE livestream (GetById / Confirm / Reveal) có thể chậm trên môi trường local; timeout đủ rộng tránh abort sớm.
axios.defaults.timeout = 180_000;
